import axios from "@/lib/axios";
import BaseInformationParams from "../types/BaseInformationParams";

const getText = (data: BaseInformationParams) => {
  return axios.get(`/facility/base_information/${data.type}?name=${data.name}`);
}

export default getText;